import { render, staticRenderFns } from "./homePage.vue?vue&type=template&id=8646770c&scoped=true"
import script from "./homePage.vue?vue&type=script&lang=js"
export * from "./homePage.vue?vue&type=script&lang=js"
import style0 from "./homePage.vue?vue&type=style&index=0&id=8646770c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8646770c",
  null
  
)

export default component.exports